import * as React from "react";
import {
	Container,
	Header,
	Button,
	Grid,
	Segment,
	Divider
} from "semantic-ui-react";
import LoginPage from "../LoginPage";
import { withRouter } from "react-router";
import RegistrationPage from "../RegistrationPage";

interface IProps {}

interface IState {
	// whatDoing: "nothing" | "login" | "register";
}

const WithRouterLogin = withRouter(LoginPage);
const WithRegistration = withRouter(RegistrationPage);


class NotLoggedInFallback extends React.Component<IProps, IState> {
	state = {
		whatDoing: "nothing"
	};

	renderButtons = () => {};

	openLogin = () => {
		this.setState({ whatDoing: "login" });
	};
	openRegister = () => this.setState({ whatDoing: "register" });

	render() {
		return (
			<Container text style={{ margin: "24px 0" }}>
				<Header size="huge" textAlign="center">
					You need to login or register
				</Header>
				<Segment style={{ maxWidth: 450, margin: "0 auto" }}>
					{this.state.whatDoing === "login" && <WithRouterLogin />}
					{this.state.whatDoing !== "login" && (
						<Button fluid onClick={this.openLogin}>
							Login
						</Button>
					)}

					<Divider horizontal>OR</Divider>

					{this.state.whatDoing === "register" && (
						<WithRegistration  />
					)}
					{this.state.whatDoing !== "register" && (
						<Button fluid onClick={this.openRegister}>
							Register
						</Button>
					)}
				</Segment>
				{/* <Grid columns={2}> */}
				{/* <WithRouterLogin/>
				 */}
				{/* </Grid> */}
			</Container>
		);
	}
}

export default NotLoggedInFallback;



// WEBPACK FOOTER //
// ./src/pages/QuestionAnswerFragment/NotLoggedInFallback.tsx